export const SET_CATEGORIAS = "CATEGORIAS/SET_CATEGORIAS";
export const SET_CATEGORIA = "CATEGORIAS/SET_CATEGORIA";
export const SET_PAGINATION = "CATEGORIAS/SET_PAGINATION";
